import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarDays, ExternalLink, MapPin, Users } from 'lucide-react';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { formatFestivalDateRange, groupFestivalsByMonth } from '../data/festivals';

export const FestivalAgendaSection = ({ festivals }) => {
  const groups = groupFestivalsByMonth(festivals);

  if (!groups.length) {
    return null;
  }

  return (
    <section className="pb-20 md:pb-24">
      <div className="container-custom">
        <div className="space-y-12">
          {groups.map(({ month, festivals: monthFestivals }) => (
            <section key={month}>
              <div className="mb-5 border-b border-border/70 pb-4">
                <h2 className="text-3xl font-heading font-bold text-foreground">
                  {month}
                </h2>
              </div>

              <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
                {monthFestivals.map((festival) => (
                  <div key={festival.id} className="rounded-2xl bg-white p-5 shadow-sm md:p-6">
                    <div className="grid gap-5 md:grid-cols-[170px,1fr] md:items-start">
                      <div className="rounded-xl bg-section-bg p-4">
                        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-accent-blue">
                          Dato
                        </div>
                        <div className="mt-2 text-lg font-semibold text-foreground">
                          {formatFestivalDateRange(festival.startDate, festival.endDate)}
                        </div>
                      </div>

                      <div>
                        <div className="mb-2 flex flex-wrap gap-2">
                          {festival.genres?.map((genre) => (
                            <Badge key={genre} variant="secondary" className="rounded-full">
                              {genre}
                            </Badge>
                          ))}
                        </div>
                        <Link to={`/festival/${festival.id}`} className="text-2xl font-heading font-bold text-foreground hover:text-accent-blue">
                          {festival.name}
                        </Link>
                        <div className="mt-3 flex flex-wrap gap-4 text-sm text-body-text">
                          <div className="flex items-center gap-2">
                            <MapPin className="h-4 w-4 text-accent-blue" />
                            <span>{festival.city}, {festival.region}</span>
                          </div>
                          {festival.approxVisitors && (
                            <div className="flex items-center gap-2">
                              <Users className="h-4 w-4 text-accent-blue" />
                              <span>Ca. {festival.approxVisitors} gæster</span>
                            </div>
                          )}
                        </div>

                        <div className="mt-5 flex flex-wrap gap-3">
                          <Button asChild variant="outline" className="border-primary/20 bg-white text-primary hover:bg-white">
                            <Link to={`/festival/${festival.id}`}>
                              Se festival
                            </Link>
                          </Button>

                          {festival.website && (
                            <Button asChild size="sm" className="rounded-lg">
                              <a href={festival.website} target="_blank" rel="noopener noreferrer">
                                Officiel side
                                <ExternalLink className="h-4 w-4" />
                              </a>
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </section>
  );
};
